import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import  './style.css';

const WeatherExtraInfo = ({humidity, wind}) => (
	<div className="humi">
		<Col xsOffset={6} xs={6}>
			<p>{`Humidity: ${humidity}%`}</p>
			<p>{` Wind: ${wind}`}</p>
		</Col>
	</div>
	)



export default WeatherExtraInfo;


// WEBPACK FOOTER //
// ./src/components/WeatherLocation/WeatherData/WeatherExtraInfo.js